import { store } from '../store/index.js';
import { startTimeout } from './executions.js';
import { addExecution, removeExecution, selectExecutionById } from '../store/reducers/executionSlice.js';
import { FlowModule } from '@code2io/fe-flow-executor';
import { setIsUnauthorizedToAccessApp } from '../store/reducers/authSlice.js';
import { getDynamicConfigValue } from '../../dynamicConfig.js';

const flowExecutor = FlowModule({
    flowManifest: {},
    mode: getDynamicConfigValue("ENVIRONMENT") === "development" ? "debug" : "prod",
    onStepCompleted: console.log,
    getAppVariables: () => {
        return Object.fromEntries(Object.entries(store.getState().variables.app).map(([id, variable]) => {
            return [id, variable.value];
        }));
    },
    getPageVariables: () => {
        const currentPage = store.getState().variables.currentPage;
        return Object.fromEntries(Object.entries(store.getState().variables.page[currentPage]).map(([id, variable]) => {
            return [id, variable.value];
        }));
    },
    onNavigate: () => {
        console.warn("Navigation function has not been set");
    },
    dispatch: store.dispatch,
    getAppState: store.getState,
    onBackendTask: backendTaskHandler
});
let timeout;
const resetTimeout = (url, evtSource, timeout) => {
    if (timeout)
        clearTimeout(timeout);
    else
        return;
    return setTimeout(() => {
        evtSource.close();
        console.log("running timeout", timeout);
        createSseCon(url);
    }, 1500);
};
const createSseCon = (url) => {
    const evtSource = new EventSource(url, { withCredentials: true });
    evtSource.addEventListener("workflowResult", (event) => {
        //console.log("workflowResult", JSON.parse(JSON.parse((event as MessageEvent).data).input));
        // assumed response fields
        const { executionId, flowId, stepId, input, context } = JSON.parse(event.data);
        const parsedInput = typeof input === "string" ? JSON.parse(input) : input;
        if (!selectExecutionById(store.getState(), executionId)) {
            // should throw maybe?
            const msg = `Execution with ID ${executionId} doesn't exist. It may have timed out`;
            flowExecutor.executionError({ executionId, errorMsg: msg });
            console.error(msg);
            return;
        }
        if (store.getState().flowExecutions.executions[executionId].stepId &&
            store.getState().flowExecutions.executions[executionId].previousStepId &&
            !input.status) {
            flowExecutor.triggerExecutionAtState(executionId, store.getState().flowExecutions.executions[executionId].feFlowId, store.getState().flowExecutions.executions[executionId].stepId, store.getState().flowExecutions.executions[executionId]
                .previousStepId, parsedInput);
        }
        else if (input.status && input.status === "failed") {
            flowExecutor.executionError({ executionId, fail: {
                    cause: input.cause,
                    error: input.error
                } });
            if (input.error === "FLOW_UPDATED") {
                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            }
        }
    }, false);
    evtSource.addEventListener("open", () => {
        store.dispatch({ type: "application/setSSEConnectionOpen", payload: true });
        setTimeout(() => {
            evtSource.dispatchEvent(new Event("error"));
        }, 10000);
    });
    evtSource.addEventListener("userdisconnect", (event) => {
        //userdisconnect
        console.log("userdisconnect", event.data);
    });
    evtSource.addEventListener("close", (event) => {
        //userdisconnect
        console.log("close", event.data);
    });
    evtSource.addEventListener("keepAlive", () => {
        timeout = resetTimeout(url, evtSource, timeout);
    }, false);
    evtSource.addEventListener("message", () => { }, false);
    evtSource.addEventListener("error", (event) => {
        console.log("error", event);
    });
    return () => evtSource.close();
};
const DEFAULT_TIMEOUT = 15000;
function backendTaskHandler(settings, input, context) {
    var _a, _b;
    const { executionId, feFlowId, beFlowId, stepId } = settings;
    // @ts-ignore
    const next = (_a = store.getState().flows.flows[feFlowId].States[stepId]) === null || _a === void 0 ? void 0 : _a.Next;
    store.dispatch(addExecution({
        executionId,
        stepId: next,
        feFlowId,
        previousStepId: stepId
    }));
    const token = store.getState().auth.token;
    const authenticate = store.getState().auth.authenticate;
    const sentInput = Object.fromEntries(Object.entries(input).filter(([k, v]) => {
        return k !== "event";
    }));
    const reqBody = {
        type: "FE",
        executionId,
        flowId: beFlowId,
        input: sentInput,
        context: {
            variables: (_b = context.variables) !== null && _b !== void 0 ? _b : {}
        }
    };
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    if (authenticate) {
        headers.append("Authorization", `Bearer ${token}`);
    }
    Object.entries(store.getState().Application.headers).forEach(([key, value]) => {
        headers.append(key, value);
    });
    const options = {
        method: "POST",
        body: JSON.stringify(reqBody),
        credentials: "include",
        headers
    };
    const postUrl = window._env_.DISPATCHER_URL +
        `/?c2ClientId=${store.getState().Application.clientId}`;
    const refreshUrl = window._env_.STUDIO_API_URL + "/jwt/refresh";
    const studioUrl = window._env_.STUDIO_URL;
    startTimeout(executionId, DEFAULT_TIMEOUT);
    if (!authenticate) {
        fetch(postUrl, options)
            .then(res => res.json())
            .then(console.log)
            .catch((err) => {
            console.error(err);
            store.dispatch(removeExecution(executionId));
        });
        return;
    }
    fetch(postUrl, options)
        .then((response) => {
        if (!response.ok) {
            if (response.status === 401) {
                // get refresh token
                fetch(refreshUrl, { credentials: "include" })
                    .then((res) => {
                    if (!res.ok) {
                        if (res.status === 401) {
                            window.location.href = `${studioUrl}/login?redirectPath=${encodeURIComponent(window.location.href)}`;
                        }
                    }
                    return res;
                })
                    .then((res) => res.json())
                    .then((json) => {
                    store.dispatch({ type: "auth/setToken", payload: json.access_token });
                    headers.set("Authorization", `Bearer ${json.access_token}`);
                    return fetch(postUrl, Object.assign(Object.assign({}, options), { headers }));
                })
                    .then((reauthorizedResult) => reauthorizedResult.json())
                    .then(console.log)
                    .catch((err) => {
                    console.error(err.message);
                    store.dispatch(removeExecution(executionId));
                });
            }
            else if (response.status === 403) {
                store.dispatch(setIsUnauthorizedToAccessApp(true));
            }
            else {
                throw new Error(response.statusText);
            }
        }
        return response.json();
    })
        .then(console.log)
        .catch((err) => {
        console.error(err.message);
        store.dispatch(removeExecution(executionId));
    });
}

export { createSseCon, flowExecutor };
//# sourceMappingURL=be-connector.js.map
